import { brandCodeMap } from '@/constants';
import { comm, base } from '../base';
const dataPickerTheme = {};

for (const item of Object.keys(brandCodeMap)) {
  dataPickerTheme[item] = {
    dataPicker: {
      navBgc: base[item]?.datePickerColor.c0003,
      color: base[item]?.datePickerColor.c0001,
      inputLabelBg: base[item]?.datePickerColor.c0003,
      inputBg: comm.color.cffff,
      inputColor: base[item]?.datePickerColor.transparent,
      borderColor: base[item]?.datePickerColor.c0004,
      dateLabelBg: base[item]?.datePickerColor.c0004,
      labelBg: base[item]?.datePickerColor.c0003,
      labelColor: base[item]?.datePickerColor.c0003,
      borderDisColor: base[item]?.datePickerColor.c0007,
      editInputBg: base[item]?.datePickerColor.c0006,
      dataDisBg: comm.color.c0001,
      dataDisColor: comm.color.c0002,
    },
  };
}

export const dataPicker = dataPickerTheme;
